import { Navigate } from '@tanstack/react-router';
import { notFoundRoute } from '../../../router';
import { useFlags } from '../../context/featureFlag';
import { UnityMessagingMFE } from './UnityMessagingMFE';

export const MessagingPage = () => {
  const { unityMessaging } = useFlags();
  if (!unityMessaging) {
    return <Navigate to={notFoundRoute.to} />;
  }
  return <UnityMessagingMFE basename="/messaging" />;
};
